import React from 'react';
import { Modal, ModalBody, } from 'reactstrap';
import moment from 'moment';
import { formatPrice, detectCreditCardType } from '../../../helpers';
import BlueishHeader from '../../common/things/BlueishHeader';
import request from 'superagent';
import config from '../../../config';
import '../../externals/signature-pad.css';
import _ from 'lodash';
var SignaturePad = require('react-signature-pad');

class BuyImpactModal extends React.Component {

    state = {
        target: null,
        mode: 1,
        signed: false,
        invalidCC: false,
        paying: false,
        paid: false,
        error: false,
        discounts: [],
        the_discount: 0,
        bootstrapped: false,
    }

    // Lifecycle
    componentWillMount() {
        const { target = {}, selectedTeam } = this.props;

        request.get(`${config.apiEndpoint}/v1/impact/impacted/${selectedTeam.IdTeam}`)
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .then((data) => {
                this.setState({ bootstrapped: true, impacted: data.body.impacted });                
            });

        this.setState({ target, team: selectedTeam || {} });
    }
    //   

    validateNewCard = () => {
        var valid = true;
        if (!this.txtCardNumber) return true; // This is when the coupon code is 100%
        if (!this.txtCardNumber.value ||
            !this.txtNameOnCard.value ||
            !this.txtExpDate.value ||
            !this.txtCVV.value ||
            !this.txtZipCode.value) {
            valid = false;
        } else if (!detectCreditCardType(this.txtCardNumber.value).Name) {
            valid = false;
        }
        return valid;
    }

    onMode = mode => this.setState({ mode });

    onPay = () => {
        const { target, discounts, the_discount, impacted } = this.state;

        if (this.validateNewCard()) {

            let selectedCard = {
                number: (this.txtCardNumber || {}).value,
                name: (this.txtNameOnCard || {}).value,
                cvv: (this.txtCVV || {}).value,
                expdate: (this.txtExpDate || {}).value,
                expDate: (this.txtExpDate || {}).value,
                zip: (this.txtZipCode || {}).value,
            }
            this.setState({ invalidCC: false, mode: 4, paying: true, paid: false, error: false }, () => {

                request.post(`${config.apiEndpoint}/v1/impact/buy`)
                    .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                    .send({
                        IdVideo: this.props.video.idVideo,
                        IdTeam: this.state.team.IdTeam,
                        total: impacted ? (target.Amount - the_discount) : 0,
                        card: selectedCard,
                        discounts
                    })
                    .then((data) => {
                        if (data.body.success) {
                            this.setState({
                                step: 4,
                                message: data.body.transactionId || data.body.externalId,
                                paying: false,
                                paid: true
                            }, () => {
                                this.props.success && this.props.success(target);
                                this.props.teamActions && this.props.teamActions.fetchVideo(this.props.video.idVideo);
                            });

                            // Remove that cart
                        } else {
                            this.setState({
                                step: 4,
                                message: data.body.message,
                                paying: false, error: true
                            })
                        }
                    }, ({ response: { body } }) => {
                        this.setState({
                            step: 4,
                            message: body.error.message,
                            paying: false,
                            error: true
                        });
                    });
            });

        } else {
            this.setState({ invalidCC: true })
        }
    }

    continue = () => {
        var signature = this.refs.mySignature;
        if (signature && signature.isEmpty()) {
            this.setState({
                signatureError: true
            });
            document.getElementById('terms-and-conditions').scrollIntoView();

        } else {
            this.setState({
                signatureDataURL: signature.toDataURL()
            }, function () {
                document.getElementById('btnPay').scrollIntoView();
            });
        }
    }

    clearSignature = () => {
        var signature = this.refs.mySignature;
        signature.clear();
        this.setState({
            signatureDataURL: null,
            signed: false
        })
    }

    signatureEnd = () => {
        this.setState({
            signed: true
        });
    }

    onCoupon = () => {
        const { discounts, target } = this.state;
        let { the_discount } = this.state;
        request.post(`${config.apiEndpoint}/api/v4/coupons/apply_membership`)
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .send({ CouponName: this.txtCoupon.value })
            .then(({ body }) => {
                // Only add it as an adjustment if the fee is not bundled                    
                const { coupon } = body;

                if (_.find(discounts, c => c.coupon.IdCoupon === coupon.IdCoupon)) {
                    // COUPON ALREADY APPLIED
                    return;
                }

                discounts.push(_.pick(coupon, 'IdCoupon', 'AmountPerCoupon', 'PercentPerCoupon', 'PromoDays', 'CouponName'));

                /*discounts.push({
                    coupon,
                    Code: this.txtCoupon.value,
                    Value: coupon.AmountPerCoupon || (target.Amount * coupon.PercentPerCoupon / 100)
                });*/
                the_discount += (coupon.AmountPerCoupon || (target.Amount * coupon.PercentPerCoupon / 100));
                this.setState({ discounts, the_discount, coupon_error: false });
            }, (error) => {
                this.setState({ coupon_error: true })
            });
    }

    render() {
        const { isOpen, toggle } = this.props,
            { target, mode, signatureError, signed, invalidCC, paying, paid, error, the_discount, bootstrapped, impacted } = this.state;



        return (
            <Modal isOpen={isOpen && bootstrapped} style={{ width: 500 }} toggle={toggle}>
                <ModalBody className="container-fluid no-margin no-padding" style={{ backgroundColor: 'white', border: '1px solid gray', borderRadius: 5, position: 'relative' }}>

                    {/* Info */}
                    {mode === 1 && (
                        <div className="d-flex flex-row justify-content-center" style={{ position: 'relative', height: 750 }}>
                            <div className="h-auto w-100 align-self-center d-flex flex-column">
                                <img src="/images/logos/impact/black.png" style={{ height: 70 }} className="align-self-center" />
                                <div style={{ height: 'auto', position: 'relative' }} className="w-100 px-4">

                                    <div className="h-100 w-100 d-flex flex-column justify-content-center p-4" style={{ border: '3px solid green', borderRadius: 6 }}>
                                        <span className="black toUpper font-16 align-self-center sqwad-font line1">IMPACT VIDEO ANALYSIS</span>
                                        {impacted && <span className="black font-16 align-self-center montserrat">{formatPrice(target.Amount * 100)} / 1 Match</span>}
                                        {!impacted &&
                                            <span className="green font-16 align-self-center sqwad-font line1">UPLOAD FOR FREE</span>}
                                    </div>
                                </div>

                                <ul className="black text-left mt-4 montserrat mx-auto" style={{ width: 350 }}>
                                    <li className="text-center"><span className="font-20 black toBold montserrat line1">Single Match Pass</span></li>
                                    <li className="text-center mb-3"><span className="font-10 black line1">Perfect for ocassional users</span></li>


                                    <li className="d-flex flex-row line1 mt-4"><i className="fas fa-clock mr-2 font-20 align-self-center" /><span className="ml-1 align-self-center">Match analysis takes roughly 4-6 hours depending on the length of the game</span></li>

                                    <li className="d-flex flex-row line1 mt-4"><i className="fas fa-envelope mr-2 font-18 align-self-center" /><span className="ml-1 align-self-center">You'll receive an email when it's finished. During that time, our computer vision and AI is analyzing</span></li>

                                    <li className="d-flex flex-row line1 mt-4"><i className="fas fa-check mr-2 font-20 align-self-center" /><span className="ml-1 align-self-center">In no time, it's status will switch from analyzing to completed</span></li>

                                </ul>
                                <div style={{ height: 40 }} />
                                <div onClick={() => this.onMode(2)} style={{ border: '3px solid #2cad3c', backgroundColor: '#2cad3c', borderRadius: 25, width: 200 }} className="m-auto p-2 text-center pointer" ><span className="white toBold montserrat">{impacted ? 'Purchase Now' : 'TAKE A FREE SHOT'}</span></div>
                                {!impacted && <div>
                                    <span className="block font-12 mt-2 text-center ">Next will be $49.99/Match</span>
                                </div>}
                                <span className="mt-4 block font-10 text-center"><a href="https://www.thesqwad.com/privacy" target="_blank" className="toBold">Terms of Service</a> and <a href="https://www.thesqwad.com/privacy" target="_blank" className="toBold">Privacy Policy</a></span>
                            </div>
                            <i className="fa fa-times font-20" style={{ position: 'absolute', top: 10, right: 10 }} onClick={toggle} />
                        </div>
                    )}

                    {/* Disclaimer */}
                    {mode === 2 && (
                        <div className="h-100" style={{ position: 'relative' }}>

                            <span className=" p-2 text-center w-100 block white">B</span>

                            <div className="bg-warning p-4 d-flex">
                                <div className="btn"><i className="fas fa-warning black font-20" /></div>
                                <span className="black font-16 toBold line1">Please only use videos that are of actual matches or full scrimmages. We cannot analyze clips, training sessions or short videos</span>
                            </div>

                            <span className=" p-2 text-left font-20 blue w-100 block ">Terms and Conditions</span>

                            <div id="terms-and-conditions" style={{ height: 359, overflowY: 'scroll' }} className="white m-auto font-8">
                                {this.props.disclaimer && this.props.disclaimer.sportslogic && (
                                    <section className="bg-white black">
                                        <div className="p-2" dangerouslySetInnerHTML={{ __html: this.props.disclaimer.sportslogic }} />
                                    </section>
                                )}
                            </div>
                            { /* Signature */}
                            {!signatureError && <span className=" p-2 text-left font-20 blue w-100 block ">Please sign here</span>}
                            {signatureError && <div className="bg-warning p-2 big-font text-center">Please Sign!</div>}
                            <div className="m-auto w-100" style={{ position: 'relative' }}>
                                <SignaturePad onEnd={this.signatureEnd} ref="mySignature" className='w-100' />
                                <button className="btn btn-link float-right" onClick={this.clearSignature} style={{ position: 'absolute', top: 0, right: 0 }}>Clear</button>
                            </div>
                            <button id="" className={`btn btn-lg btn-block btn-${signed ? 'success' : 'info'} bigest-font`} onClick={() => this.onMode(3)}>Continue</button>

                            <i className="fa fa-arrow-left font-18" style={{ position: 'absolute', top: 6, left: 8 }} onClick={() => this.onMode(1)} />

                        </div>
                    )}

                    {/* Payment */}
                    {mode === 3 && <div className="h-100" style={{ position: 'relative' }}>
                        <span className=" p-2 text-center w-100 block white">B</span>
                        <div style={{ height: 150, position: 'relative' }} className="w-100 p-4">

                            <div className="h-100 w-100 d-flex flex-column justify-content-center" style={{ border: '3px solid green', borderRadius: 6 }}>

                                <span className=" font-20 align-self-center">Total: {formatPrice((impacted ? (target.Amount - the_discount) : 0) * 100)}</span>

                                {the_discount > 0 && <span className="black font-10">Discount: -{formatPrice(the_discount * 100)}</span>}
                            </div>
                        </div>
                        {impacted && <section>
                            
                            
                        {(target.Amount - the_discount) > 0 && <section className={`m-auto font-12 align-self-center bg-white px-4`} style={{ position: 'relative' }}>
                            <div className="d-flex flex-row">

                                <input className="form-control align-self-center p-4 w-75" maxLength="16" type="text" ref={(i) => this.txtCoupon = i} placeholder='Coupon Code' />

                                <button onClick={this.onCoupon} className="btn btn-default btn-lg w-25 align-self-center" style={{ backgroundColor: 'gray', color: 'white' }}>Apply</button>

                            </div>
                            <div>
                                {the_discount > 0 && <span className='green font-12 ml-2 align-self-center'>Discount applied!</span>}
                                {this.state.coupon_error && <span className='red font-12 ml-2 align-self-center'>Invalid Coupon Code</span>}
                            </div>
                        </section>}
                        {(target.Amount - the_discount) > 0 && !invalidCC && <span className=" p-2 text-left font-20 blue w-100 block ">Credit Card Information</span>}
                        {(target.Amount - the_discount) > 0 && invalidCC && <div className="bg-warning p-2 big-font text-center">Invalid Credit Card!</div>}
                        {(target.Amount - the_discount) > 0 && <section className={`mx-auto font-12 align-self-center bg-white px-2`} style={{ position: 'relative' }}>
                            <div className="d-flex flex-row pt-2 pl-2 pr-2">
                                <input className="form-control align-self-center p-4 w-100" placeholder="Card Number" maxLength="16" type="text" ref={(i) => this.txtCardNumber = i} />
                            </div>
                            <div className="d-flex flex-row pt-2 pl-2 pr-2">
                                <input className="form-control align-self-center p-4 w-100" placeholder="Name on Card" type="text" ref={(i) => this.txtNameOnCard = i} />
                            </div>
                            <div className="d-flex flex-row pt-2 pl-2 pr-2">
                                <input className="form-control align-self-center p-4 w-100" placeholder="Exp. Date (MMYY)" maxLength="4" type="text" ref={(i) => this.txtExpDate = i} />
                                <div style={{ width: 20 }} />
                                <input className="form-control align-self-center p-4 w-100" placeholder="CVV" type="text" maxLength="4" ref={(i) => this.txtCVV = i} />
                            </div>
                            <div className="d-flex flex-row py-2 px-2">
                                <input className="form-control align-self-center p-4 w-50" placeholder="Zip | Postal" type="text" ref={(i) => this.txtZipCode = i} />
                            </div>
                        </section>}
                        </section>}
                        <button id="btnPay" className="btn btn-lg btn-block btn-success bigest-font align-self-end" onClick={this.onPay}>{`Pay ${formatPrice((impacted ? (target.Amount - the_discount) : 0) * 100)}`}</button>


                        <i className="fa fa-arrow-left font-20" style={{ position: 'absolute', top: 10, left: 10 }} onClick={() => this.onMode(2)} />
                    </div>}
                    {mode === 4 && <div className="bg-dark-blue d-flex flex-row justify-content-center" style={{ height: 400 }}>
                        {paying && <div className="h-auto d-flex flex-column justify-content-center no-margin text-center" key="step1">
                            <i className="fa fa-credit-card bigest-font heart align-self-center white" />
                            <h1 className="margin-top-half align-self-center white">Processing, please wait...</h1>
                        </div>}
                        {paid && <div className="h-auto w-100 d-flex flex-column justify-content-center no-margin text-center bg-success" key="step2" onClick={toggle}>
                            <i className="fa fa-check white bigest-font" />
                            <h1 className="white">Registration successful</h1>
                            {/*<h3 className="white">{formatPrice(target.Amount * 100)}</h3>*/}
                            <h3 className="white font-8">{this.state.message}</h3>
                        </div>}
                        {error && <div className="h-auto w-100 d-flex flex-column justify-content-center no-margin text-center bg-danger"
                            onClick={() => this.onMode(3)} key="step3" style={{ position: 'relative' }}>
                            <i className="fa fa-times white bigest-font" />
                            <h1 className="white">Registration failed</h1>
                            <h3 className="white pl-2 pr-2">{this.state.message}</h3>
                            <i className="fa fa-arrow-left font-20 white" style={{ position: 'absolute', top: 10, left: 10 }} />
                        </div>}
                    </div>}
                </ModalBody>
            </Modal>
        )
    }
}

export default BuyImpactModal;
